/* Unbroken Vine — bundle selector.

   Deliberately small. Everything that costs money is server-side: the tier
   discounts are Shopify automatic discounts and the free bracelet is handled by
   gift-with-purchase.js. This file only keeps the visible state honest:
     1. the chosen tier writes its quantity into the product form
     2. picking a variant re-does the arithmetic against the new unit price

   It touches nothing else on the page, so a failure here leaves a working
   product form with whatever quantity was last set. */
(function () {
  'use strict';

  function money(cents) {
    /* Shopify's money filter runs server-side; on the client the shop's own
       format string is the only reliable source. Fall back to plain currency
       rather than inventing a format. */
    var fmt = window.Shopify && window.Shopify.money_format;
    var value = (cents / 100).toFixed(2);
    if (!fmt) return value;
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  class BundleSelector extends HTMLElement {
    connectedCallback() {
      this.hidden_input = this.querySelector('[data-bundle-quantity]');
      this.options = Array.from(this.querySelectorAll('.bundle-selector__option'));

      this.addEventListener('change', this.onChange.bind(this));

      /* Dawn republishes the price block on variant change. Watch the section
         for that swap rather than guessing at an event name, because the event
         has been renamed twice across Dawn versions and the DOM has not. */
      var price = document.getElementById('price-' + this.sectionId());
      if (price) {
        this.observer = new MutationObserver(this.onVariantChange.bind(this));
        this.observer.observe(price, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    sectionId() {
      var form = this.dataset.form || '';
      return form.replace(/^product-form-/, '');
    }

    onChange(event) {
      if (!event.target.classList.contains('bundle-selector__radio')) return;
      var option = event.target.closest('.bundle-selector__option');
      if (!option) return;

      this.options.forEach(function (o) { o.classList.toggle('is-selected', o === option); });
      if (this.hidden_input) this.hidden_input.value = option.dataset.quantity;
    }

    /* Re-price every tier from the newly selected variant. The unit price is
       read out of Dawn's rendered price block, so there is one source of truth
       and no second fetch. */
    onVariantChange() {
      var el = document.querySelector('#price-' + this.sectionId() + ' .price-item--sale')
            || document.querySelector('#price-' + this.sectionId() + ' .price-item--regular');
      if (!el) return;
      var unit = this.parseMoney(el.textContent);
      if (!unit || unit === Number(this.dataset.unit)) return;

      /* The struck price scales with the variant too. Keep the ratio between
         compare-at and price so the savings stay honest after a variant swap. */
      var oldUnit = Number(this.dataset.unit) || unit;
      var oldCompare = Number(this.dataset.compareUnit) || oldUnit;
      var compareUnit = Math.round(unit * (oldCompare / oldUnit));
      this.dataset.unit = unit;
      this.dataset.compareUnit = compareUnit;

      this.options.forEach(function (option) {
        var qty = Number(option.dataset.quantity) || 1;
        var off = Number(option.dataset.amountOff) || 0;
        var compare = compareUnit * qty;
        var total = Math.max(unit * qty - off, 0);

        option.dataset.total = total;
        option.dataset.compare = compare;

        var priceEl = option.querySelector('.bundle-selector__price');
        if (priceEl) priceEl.textContent = money(total);

        var compareEl = option.querySelector('.bundle-selector__compare');
        if (compareEl) compareEl.textContent = compare > total ? money(compare) : '';

        var caption = option.querySelector('.bundle-selector__caption');
        if (caption && caption.dataset.captionTemplate) {
          caption.textContent = caption.dataset.captionTemplate
            .replace(/\[amount_saved\]/g, money(compare - total))
            .replace(/\[price\]/g, money(total))
            .replace(/\[compare_price\]/g, money(compare))
            .replace(/\[quantity\]/g, qty);
        }
      });
    }

    parseMoney(text) {
      var digits = (text || '').replace(/[^\d.,]/g, '').trim();
      if (!digits) return 0;
      /* "1.234,56" (comma decimal) vs "1,234.56" (period decimal): whichever
         separator comes last is the decimal one. */
      var lastComma = digits.lastIndexOf(',');
      var lastDot = digits.lastIndexOf('.');
      if (lastComma > lastDot) digits = digits.replace(/\./g, '').replace(',', '.');
      else digits = digits.replace(/,/g, '');
      return Math.round(parseFloat(digits) * 100) || 0;
    }
  }

  if (!customElements.get('bundle-selector')) {
    customElements.define('bundle-selector', BundleSelector);
  }
})();
